// extracted by mini-css-extract-plugin
export default {"statisticsCard":"AverageOrderSizeCard_statisticsCard__qihJK","description":"AverageOrderSizeCard_description__9Xh5P"};